"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackSearchAndReplaceCommand = void 0;

var trackSearchAndReplaceCommand = function trackSearchAndReplaceCommand(editor) {
  editor.shortcuts.add('Meta+F', '', function () {
    editor.execCommand('SearchReplace');
  });
};

exports.trackSearchAndReplaceCommand = trackSearchAndReplaceCommand;